export enum SectionSpanTypes {
    CodeRef = "nfpa-html_coderef",
    Label = "nfpa-html_label",
}
